/**
 * Barre de navigation persistante de l'espace élève (fixe en bas).
 * Présentationnelle : props { active, onChange }. Masquée pendant une activité
 * (quiz / correction) car EspaceEleve ne la rend pas dans ces vues plein écran.
 */
const TABS = [
  { id: 'jouer', label: 'Jouer', emoji: '▶️' },
  { id: 'ile', label: 'Île', emoji: '🌍' },
  { id: 'blasons', label: 'Blasons', emoji: '🛡️' },
  { id: 'moi', label: 'Moi', emoji: '🙂' },
];

function TabBarEleve({ active, onChange }) {
  return (
    <nav
      className="eleve-gamified"
      style={{ background: 'rgba(8,20,40,.97)', borderTop: '1px solid rgba(255,255,255,.1)' }}
    >
      {/* Contenu centré (colonne app) → ne s'étale pas sur grand écran */}
      <div className="w-full max-w-md mx-auto h-16 flex items-stretch justify-around">
        {TABS.map((t) => {
          const on = active === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => onChange(t.id)}
              aria-current={on ? 'page' : undefined}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 text-[10px] font-bold transition-colors"
              style={{ color: on ? '#29B6E8' : 'rgba(255,255,255,.5)' }}
            >
              <span className="text-xl leading-none">{t.emoji}</span>
              {t.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default TabBarEleve;
